<template>
  <ClientOnly v-if="video">
    <div
      :class="{
        ['wistia_embed wistia_async_' + video[0].hashed_id]: true,
        'popover=true popoverContent=html': true,
      }"
    >
      <button
        id="watch-video"
        type="button"
        :class="{
          'group relative mt-30px grid w-full border-s-[56px] border-s-www-color-primary-dark bg-www-color-primary-light p-5 pb-13px font-ptc-Rajdhani font-bold transition-colors duration-300 ease-in-out hover:bg-www-color-white lg:w-auto': true,
          'before:absolute before:-left-[30px] before:top-1/2 before:-translate-y-1/2 before:border-[6px] before:border-www-color-transparent before:border-l-www-color-white before:content-[\'\']': true,
        }"
      >
        <span
          :class="{
            'text-lg uppercase leading-none transition-colors duration-300 ease-in-out group-hover:text-www-color-black': true,
          }"
        >
          <slot />
        </span>
        <span
          v-if="duration"
          :class="{
            'text-10px text-www-color-black': true,
          }"
          >{{ formatDuration(duration) }}</span
        >
      </button>
    </div>
  </ClientOnly>
</template>

<script lang="ts" setup>
import type { InlineWistiaVideo } from '~/sanity/types';

defineProps<InlineWistiaVideo & { duration?: number }>();

useHead({
  script: [
    { hid: 'wistia-script', src: 'https://fast.wistia.com/assets/external/E-v1.js', async: true },
  ],
});
</script>
